import React from "react";
import PageHero from "../components/PageHero";
import { AlertTriangle, ShieldAlert, PhoneCall, Heart, Ban, Brain } from "lucide-react";
import { SITE } from "../data/mock";

export default function ResponsibleGambling() {
  return (
    <div>
      <PageHero title="Responsible Gambling" breadcrumb="Responsible Gambling" subtitle="Gaming ek entertainment hai - addiction nahi. Apni limits jaaniye aur safe play kariye. OnlineCricketID 18+ users ke liye hai." />

      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <div className="card-dark p-6 md:p-8 border-amber-500/30">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-6 h-6 text-amber-400 mt-0.5 shrink-0" />
              <div>
                <h2 className="text-xl font-bold text-white">Important Warning</h2>
                <p className="mt-2 text-slate-300">Betting involves real financial risk. Sirf utna hi paisa lagayein jitna aap khone ko taiyaar hain. OnlineCricketID 18 saal se kam umar wale users ke liye nahi hai.</p>
              </div>
            </div>
          </div>

          {[
            { icon: Brain, t: "Self-Awareness Rakhein", d: "Agar aap baar-baar loss recover karne ke liye bet kar rahe ho, ya budget se zyada paisa lagana padta hai — yeh warning sign hai. Pause karein aur situation review karein." },
            { icon: ShieldAlert, t: "Limits Set Karein", d: "Hamesha daily/weekly deposit aur loss limit set karein. Bet amount budget ka 1-5% se zyada nahi hona chahiye." },
            { icon: Ban, t: "Account Self-Exclusion", d: "Agar aapko lagta hai control kho raha hai, to humari support team se contact karke apna account temporary ya permanent pause kara sakte hain." },
            { icon: Heart, t: "Help Available Hai", d: "Gambling addiction ek serious issue hai. Aap akele nahi hain — helplines aur counseling services available hain." },
          ].map((x) => (
            <div key={x.t} className="card-dark p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center shrink-0"><x.icon className="w-6 h-6 text-amber-400" /></div>
                <div>
                  <h3 className="text-lg font-bold text-white">{x.t}</h3>
                  <p className="mt-2 text-slate-300 leading-relaxed">{x.d}</p>
                </div>
              </div>
            </div>
          ))}

          <div className="card-dark p-6 md:p-8">
            <h2 className="text-xl font-bold text-white">Helplines & Resources</h2>
            <ul className="mt-4 space-y-2.5 text-slate-300 text-sm">
              <li>• <strong>BeGambleAware.org</strong> — free counseling and information</li>
              <li>• <strong>iCall (India)</strong> — 9152987821, free mental health helpline</li>
              <li>• <strong>Vandrevala Foundation</strong> — 1860-2662-345, 24x7 mental health support</li>
            </ul>
            <a href={SITE.whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-5 py-3 rounded-xl mt-6 text-sm"><PhoneCall className="w-4 h-4" /> Need help with your account? Contact us</a>
          </div>
        </div>
      </section>
    </div>
  );
}
